export default __webpack_public_path__ + "static/media/1002.ba50fab9.png";